"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._parse = exports.call = exports.isOptional = void 0;
var Nothing_1 = require("../Nothing");
// endregion
// region optional & strict
/**
 * @internal
 */
var isOptional = function (v) {
    return v.__type === "optional";
};
exports.isOptional = isOptional;
/**
 * @internal
 */
var call = function (p, v) {
    switch (p.__type) {
        case "optional":
        case "strict":
            return p.fn(v);
        default:
            return p(v);
    }
};
exports.call = call;
/**
 * @internal
 */
function _parse(parsers, object) {
    var b = {};
    for (var p in parsers) {
        if (!Object.prototype.hasOwnProperty.call(parsers, p)) {
            continue;
        }
        var v = exports.call(parsers[p], object);
        if (!exports.isOptional(parsers[p]) && Nothing_1.isNothing(v)) {
            return undefined;
        }
        b[p] = v;
    }
    return b;
}
exports._parse = _parse;
// endregion
